// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyA1eGJhc1x1W92oKioSmm0IZ7xwwHZxHWc",
  authDomain: "regulamais-463618.firebaseapp.com",
  projectId: "regulamais-463618",
  storageBucket: "regulamais-463618.firebasestorage.app",
  messagingSenderId: "406470295622",
  appId: "1:406470295622:web:c7ab9e5b71320d12f28a47",
  measurementId: "G-VZ0Y0WJ3VC"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');

export default app;
